import { Injectable } from '@angular/core';
import detectIncognito from './detectIncognito';

@Injectable({ providedIn: 'root' })
export class IncognitoService {
  private status: boolean | null = null;

  detect(): Promise<void> {
    return detectIncognito()
      .then((res) => {
        this.status = res.isPrivate;
      })
      .catch(() => {
        this.status = null;
      });
  }

  getBrowserName(): string {
    const userAgent = navigator.userAgent;
    let browserName = 'Unknown';

    if (/chrome|crios|crmo/i.test(userAgent) && !/edge|edg|opr|opera/i.test(userAgent)) {
      browserName = 'Chrome';
    } else if (/firefox|fxios/i.test(userAgent)) {
      browserName = 'Firefox';
    } else if (/safari/i.test(userAgent) && !/chrome|crios|crmo|android/i.test(userAgent)) {
      browserName = 'Safari';
    } else if (/edg/i.test(userAgent)) {
      browserName = 'Edge';
    } else if (/opr|opera/i.test(userAgent)) {
      browserName = 'Opera';
    } else if (/msie|trident/i.test(userAgent)) {
      browserName = 'Internet Explorer';
    }
    if (this.status) {
      return `${browserName}Incognito`;
    }
    return browserName;
  }
}
